import type { BaseItemSchema } from "@memorang/types";
import { useCallback } from "react";
import { toPersistableBlankValues } from "../helpers/ai-feedback";
import useAIFeedbackStore from "./useAIFeedbackStore";
import useItemAnsweredState from "./useItemAnsweredState";
import useSessionStore from "./useSessionStore";

const EMPTY_FORM_STATE: Record<string, string> = {};

const useBlankFormState = (item: BaseItemSchema) => {
	const itemId = item.id;
	const { isAnswered, inReviewMode } = useItemAnsweredState(item);

	const values = useSessionStore(
		(s) =>
			(itemId != null ? s.formStates?.[itemId] : undefined) ??
			item.answer?.selectedBlankValues ??
			EMPTY_FORM_STATE,
	);
	const updateFormStates = useSessionStore((s) => s.updateFormStates);
	const setUserResponse = useAIFeedbackStore((s) => s.setUserResponse);

	const handleChangeValues = useCallback(
		(next: Record<string, string>) => {
			if (itemId != null) {
				updateFormStates(itemId, next);
				// Answer submission reads userResponse, not formStates; without this
				// mirror the server sees an empty response and counts the item skipped.
				setUserResponse(itemId, toPersistableBlankValues(next));
			}
		},
		[itemId, setUserResponse, updateFormStates],
	);

	return { values, handleChangeValues, isAnswered, inReviewMode };
};

export default useBlankFormState;
